import React from 'react';

import { GraphQLSubscription } from '@aws-amplify/api';
import { API } from 'aws-amplify';

import { DeleteChatMessageInfo } from '../../graphql/API';
import { onAdminDeleteChatMessage } from '../../graphql/subscriptions';
import { GqlError, getError, getErrorFromResult, processGqlResult } from '../../utils/gql-utils';

export const useOnAdminDeleteChatMessageListener = (
  messageTime?: string,
  conversationId?: string,
) => {
  const [message, setMessage] = React.useState<Nullable<DeleteChatMessageInfo>>(null);
  const [error, setErorr] = React.useState<GqlError>();

  React.useEffect(() => {
    if (messageTime && conversationId) {
      const createSub = API.graphql<GraphQLSubscription<DeleteChatMessageInfo>>({
        query: onAdminDeleteChatMessage,
        variables: { messageTime, conversationId },
      }).subscribe({
        next: ({ value }) => {
          const _message = processGqlResult<DeleteChatMessageInfo>('onAdminDeleteChatMessage', value);
          setMessage(_message);
          const errorFromResponse = getErrorFromResult(value);

          if (errorFromResponse) {
            throw errorFromResponse;
          }
        },
        error: (ex) => {
          const raisedError = getError(ex);
          console.error(raisedError);
          setErorr(raisedError);
        },
      });

      return () => {
        createSub.unsubscribe();
      };
    }
  }, [setMessage, conversationId, messageTime]);

  return {
    message,
    error,
  };
};
